import _ from "lodash"
import defaultMessages from "../../i18n/default.messages"

export default _.merge({
    messages: {
    'es-MX': {
        signin: 'TSMX Digital - Smart App Management',
        language: 'Cambiar idioma',
        login: 'Login con TS-MEX',
    },
    en: {
      signin: 'TSMX Digital - Smart App Management',
      language: 'shift language',
      login: 'Login with TS-MEX',
    }
  }
}, defaultMessages)
